module.exports = __webpack_public_path__ + "img/7c4a3e8.webp";